import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaLeadVisualizacaoModoComponent } from './campanha-lead-visualizacao-modo.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CampanhaLeadVisualizacaoModoComponent
    ],
    exports: [
        CampanhaLeadVisualizacaoModoComponent
    ]
})
export class CampanhaLeadVisualizacaoModoModule { }
